import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Select, Tooltip, Icon } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import chartsConfig from '../../common/chartsConfig';
import DateRange from '../../common/DateRange.new.js';
import Highcharts from 'react-highcharts';
import SideNav from '../SideNav';
import moment from 'moment';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const constants = {
    cumVisit: {
        title: '累计完成访视',
        chartsType: 'line',
        params: {
            investigationId: 1,
            investigationSiteId: '',
            cumulative: 1,
          },
    },
    monVisit: {
        title: '每月完成访视',
        chartsType: 'column',
        params: {
            investigationId: 1,
            investigationSiteId: '',
            cumulative: 0,
        },
    }
};

class FinishVisit extends Component {
    constructor(props) {
        super(props);
        const { settlementType } = props;
        this.state = {
            loading: false,
            tableData: [],
            chartData: [],
            categories: [],
            searchParams: {
                settlementType,
                begin: moment().add(-11, 'M').format(monthFormat),
                end: moment().format(monthFormat),
            },
        };
    }

    componentDidMount() {
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG',
        ];
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.name !== prevProps.match.params.name) {
            this.loadData();
        }
        if (this.props.settlementType !== prevProps.settlementType) {
            const { searchParams } = this.state;
            searchParams.settlementType = this.props.settlementType;
            this.setState({ searchParams }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { searchParams } = this.state;
        const { name } = this.props.match.params;
        const params = constants[name]['params'];
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.summary.visit,
            data: {
                ...params,
                ...searchParams,
            },
            dateType: 'json',
            doneResult: res => {
                const { datas = [], monthList = [], visitTypeNames = [] } = res.data;
                const tableData = [];
                const chartData = [];
                const categories = [];
                for (let i = 0; i < monthList.length; i++) {
                    const { month } = monthList[i];
                    categories.push(month);
                }

                const totalRow = {};
                for (let i = 0; i < visitTypeNames.length; i++) {
                    const data = datas[i];
                    data.forEach((item, index) => {
                        const { month, amount } = item;
                        const tableColumn = tableData[i] || (tableData[i] = {});
                        if (!tableColumn.title) {
                            tableColumn.title = visitTypeNames[i];
                        }
                        tableColumn[month] = amount;

                        const chartColumn = chartData[i] || (chartData[i] = { data: [] });
                        if (!chartColumn.name) {
                            chartColumn.name = visitTypeNames[i];
                        }
                        chartColumn.data.push(amount);

                        if (!totalRow.title) {
                            totalRow.title = '总计';
                        }
                        totalRow[month] = (totalRow[month] || 0) + amount;
                    });
                }
                tableData.push(totalRow);

                this.setState({
                    tableData,
                    chartData,
                    categories,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options)
    }

    getColumns = () => {
        const { categories } = this.state;
        const columns = [{
            title: '',
            dataIndex: 'title',
            key: 'title',
        }];
        categories.forEach(i => {
            columns.push({
                title: `${i}月`,
                dataIndex: i,
                key: i,
            });
        });
        return columns
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        this.setState({ searchParams }, () => {
            this.loadData();
        });
    }

    handleDateChange = (value) => {
        const { searchParams } = this.state;
        const [begin, end] = value;
        searchParams.begin = begin;
        searchParams.end = end;
        this.setState({ searchParams }, () => {
            if (begin && end) {
                this.loadData();
            }
        });
    }

    getChartConfig = () => {
        const { chartData, categories } = this.state;
        const newCategories = categories.map(i => `${i}月`);
        const { name } = this.props.match.params;

        const config = {
            title: {
                text: ''
            },
            chart: {
                type: constants[name]['chartsType'],
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            yAxis: {
                title: {
                    text: ''
                },
            },
            xAxis: {
                categories: newCategories,
            },
            series: chartData,
            exporting: {
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            credits: {
                enabled: false,
                text: 'SMO医疗大数据',
            },
        };
        return config;
    }

    render() {
        const { loading, tableData, searchParams: { begin, end, settlementType } } = this.state;
        const { name } = this.props.match.params;
        const config = this.getChartConfig();
        const tipInfo = (
            <span>
                1、自然月，表示每月统计的数据范围，<br />
                为本月1号~月底产生的数据。<br />
                2、工时结算月，表示每月统计的数据<br />
                范围，为上月26号~本月25号产生的数据。
            </span>
        )
        return (
            <div className="content">
                <SideNav />
                <div className="main">
                    <Spin spinning={loading}>
                        <div className="T-tit">
                            <div className="txt">
                                <h3 style={{ marginBottom: 10 }}>{constants[name]['title']} </h3>
                            </div>
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <span style={{marginRight: 10}}>统计维度:</span>
                            <Select style={{marginRight: 10, width: 110}} value={settlementType} onChange={value => this.handleSelectChange(value, 'settlementType')}>
                                <Option value='BILLING_MONTH'>按工时结算月</Option>
                                <Option value='NATURAL_MONTH'>按自然月</Option>
                            </Select>
                            <Tooltip placement="top" title={tipInfo}>
                                <a><Icon style={{ marginRight: 10, fontSize: '14px', color: '#5750c9' }} type="info-circle" /></a>
                            </Tooltip>
                            <DateRange
                                separator="~"
                                allowClear={false}
                                value={[begin, end]}
                                style={{width: 100}}
                                disabledDate={[11, 'M']}
                                onChange={this.handleDateChange}
                            />
                        </div>
                        <div className="charts" style={{ marginBottom: 10 }}>
                            <Highcharts config={{ ...config, ...chartsConfig }} />
                        </div>
                        <TableC
                            className="finishVisit"
                            data={tableData}
                            columns={this.getColumns()}
                            pagination={false}
                        />
                    </Spin>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { inProjectState: { settlementType } } = state;
    return {
        settlementType,
    };
};

export default connect(mapStateToProps, null)(FinishVisit);


// WEBPACK FOOTER //
// ./src/components/summary/finishVisit/index.js